import { datadogLogs } from '@datadog/browser-logs';
import * as qs from 'qs';
import { createPIIExcludedLeadLog } from '../create-pii-excluded-lead-log';
var retrieveAccountOriginFromQueryString = function () {
    var queryString = qs.parse(location === null || location === void 0 ? void 0 : location.search, { ignoreQueryPrefix: true });
    return (queryString === null || queryString === void 0 ? void 0 : queryString.origin) || '';
};
var retrieveAccountOriginFromLeadData = function (leadData) {
    var _a;
    try {
        return (leadData === null || leadData === void 0 ? void 0 : leadData.accountOrigin) || ((_a = leadData === null || leadData === void 0 ? void 0 : leadData.data) === null || _a === void 0 ? void 0 : _a.accountOrigin) || '';
    }
    catch (_b) {
        return '';
    }
};
export var retrieveAccountOrigin = function (leadData) {
    try {
        return leadData && retrieveAccountOriginFromLeadData(leadData)
            ? retrieveAccountOriginFromLeadData(leadData)
            : retrieveAccountOriginFromQueryString();
    }
    catch (error) {
        datadogLogs.logger.error('An error occurred while attempting to retrieve account origin from lead data.', { leadData: leadData ? createPIIExcludedLeadLog(leadData) : {} }, error);
        return '';
    }
};
//# sourceMappingURL=index.js.map